import React, { useState, useEffect, useRef } from 'react';

export default function CockpitView({ activeView, onNavigate, onOpenModal, onShowToast, troLyData }) {
    const revCanvasRef = useRef(null);
    const nppCanvasRef = useRef(null);
    const revChartRef = useRef(null);
    const nppChartRef = useRef(null);
    const [activeFilter, setActiveFilter] = useState('revenue');

    useEffect(() => {
        const timer = setTimeout(() => {
            if (!window.Chart) return;
            if (revCanvasRef.current && !revChartRef.current) {
                revChartRef.current = new window.Chart(revCanvasRef.current, {
                    data: {
                        labels: ['14/08', '15/08', '16/08', '17/08', '18/08', '19/08', '20/08'],
                        datasets: [
                            {
                                type: 'line',
                                label: 'Trung bình 7 ngày (1.35 Tỷ)',
                                data: [1.35, 1.35, 1.35, 1.35, 1.35, 1.35, 1.35],
                                borderColor: '#ca8a04',
                                borderWidth: 1.5,
                                borderDash: [4, 4],
                                pointRadius: 0,
                                fill: false
                            },
                            {
                                type: 'line',
                                label: 'Doanh thu thực tế',
                                data: [1.20, 1.28, 1.15, 1.42, 1.38, 1.52, 1.45],
                                borderColor: '#10b981',
                                borderWidth: 2,
                                pointBackgroundColor: '#10b981',
                                pointRadius: 3,
                                fill: false
                            },
                            {
                                type: 'bar',
                                label: 'Doanh số chothuoc247',
                                data: [1.20, 1.28, 1.15, 1.42, 1.38, 1.52, 1.45],
                                backgroundColor: 'rgba(16, 185, 129, 0.65)',
                                borderRadius: 4,
                                barThickness: 16
                            }
                        ]
                    },
                    options: {
                        responsive: true,
                        maintainAspectRatio: false,
                        plugins: {
                            legend: {
                                display: true,
                                position: 'bottom',
                                labels: {
                                    color: '#94a3b8',
                                    font: { family: 'Inter', size: 10 },
                                    boxWidth: 12,
                                    padding: 6
                                }
                            }
                        },
                        scales: {
                            y: {
                                min: 0,
                                max: 2.0,
                                ticks: { color: '#64748b', font: { size: 10 } },
                                grid: { color: 'rgba(255, 255, 255, 0.04)' }
                            },
                            x: {
                                ticks: { color: '#94a3b8', font: { size: 10 } },
                                grid: { display: false }
                            }
                        }
                    }
                });
            }

            if (nppCanvasRef.current && !nppChartRef.current) {
                nppChartRef.current = new window.Chart(nppCanvasRef.current, {
                    type: 'doughnut',
                    data: {
                        labels: ['PRJ-TTP', 'PRJ-TOP', 'PRJ-TTCE', 'PRJ-TECHPHA'],
                        datasets: [
                            {
                                data: [78, 64, 85, 42],
                                backgroundColor: ['#10b981', '#3b82f6', '#f59e0b', '#ef4444'],
                                borderWidth: 0
                            }
                        ]
                    },
                    options: {
                        responsive: true,
                        maintainAspectRatio: false,
                        plugins: { legend: { display: false } },
                        cutout: '72%'
                    }
                });
            }
        }, 150);

        return () => {
            clearTimeout(timer);
            if (revChartRef.current) {
                revChartRef.current.destroy();
                revChartRef.current = null;
            }
            if (nppChartRef.current) {
                nppChartRef.current.destroy();
                nppChartRef.current = null;
            }
        };
    }, []);

    const switchRevChart = (type, label) => {
        setActiveFilter(type);
        if (!revChartRef.current) return;
        const chart = revChartRef.current;
        if (type === 'orders') {
            chart.data.datasets[1].data = [85, 92, 78, 110, 105, 125, 118];
            chart.data.datasets[2].data = [85, 92, 78, 110, 105, 125, 118];
            chart.data.datasets[0].data = [100, 100, 100, 100, 100, 100, 100];
            chart.options.scales.y.max = 150;
        } else if (type === 'savings') {
            chart.data.datasets[1].data = [12, 14, 11, 16, 15, 18, 17];
            chart.data.datasets[2].data = [12, 14, 11, 16, 15, 18, 17];
            chart.data.datasets[0].data = [14, 14, 14, 14, 14, 14, 14];
            chart.options.scales.y.max = 25;
        } else if (type === 'pharmacies') {
            chart.data.datasets[1].data = [180, 195, 175, 220, 210, 245, 230];
            chart.data.datasets[2].data = [180, 195, 175, 220, 210, 245, 230];
            chart.data.datasets[0].data = [200, 200, 200, 200, 200, 200, 200];
            chart.options.scales.y.max = 300;
        } else {
            chart.data.datasets[1].data = [1.20, 1.28, 1.15, 1.42, 1.38, 1.52, 1.45];
            chart.data.datasets[2].data = [1.20, 1.28, 1.15, 1.42, 1.38, 1.52, 1.45];
            chart.data.datasets[0].data = [1.35, 1.35, 1.35, 1.35, 1.35, 1.35, 1.35];
            chart.options.scales.y.max = 2.0;
        }
        chart.update();
        onShowToast(`Đã chuyển chỉ số: ${label}`);
    };

    return (
        <div id="view-cockpit" className={`view-panel ${activeView === 'view-cockpit' ? 'active' : ''}`}>

            {/*  Greeting Bar  */}
            <div className="greeting-bar">
                <div className="greeting-left">
                    <i className="fa-solid fa-sun greeting-sun-icon"></i>
                    <div className="greeting-text">
                        <h2>Chào buổi sáng, Ban Lãnh Đạo (Anh Thế &amp; Chị Thảo)!</h2>
                        <span>Hôm nay là Thứ Năm, 20/08/2026 • 08:00 (Hệ thống Techmedcom)</span>
                    </div>
                </div>
                <div className="system-health-tag">
                    <div className="health-dot"></div>
                    <span>OpenClaw + 9Router: Đồng bộ 100% CSDL chothuoc247.vn</span>
                </div>
            </div>

            {/*  6 Executive KPI Cards Row  */}
            <div className="kpi-row-6">
                <div className="kpi-box">
                    <div className="kpi-box-title">DOANH THU HÔM QUA (chothuoc247)</div>
                    <div className="kpi-main-val-row">
                        <div className="kpi-main-val" style={{ "color": "var(--green)" }}>1.45 Tỷ</div>
                        <i className="fa-solid fa-arrow-trend-up sparkline-icon" style={{ "color": "var(--green)" }}></i>
                    </div>
                    <div className="kpi-sub-text" style={{ "color": "var(--green)" }}>▲ 14.2% so với hôm trước</div>
                </div>

                <div className="kpi-box">
                    <div className="kpi-box-title">DOANH THU THÁNG 8 (TOÀN HỆ THỐNG)</div>
                    <div className="kpi-main-val-row">
                        <div className="kpi-main-val" style={{ "color": "var(--green)" }}>28.6 Tỷ</div>
                        <i className="fa-solid fa-chart-simple sparkline-icon" style={{ "color": "var(--green)" }}></i>
                    </div>
                    <div className="kpi-sub-text" style={{ "color": "var(--green)" }}>▲ 18.5% so với cùng kỳ</div>
                </div>

                <div className="kpi-box">
                    <div className="kpi-box-title">TASKS AI ĐANG HOẠT ĐỘNG</div>
                    <div className="kpi-main-val-row">
                        <div className="kpi-main-val" style={{ "color": "var(--gold-light)" }}>34 Tasks</div>
                        <i className="fa-solid fa-list-check sparkline-icon" style={{ "color": "var(--gold-light)" }}></i>
                    </div>
                    <div className="kpi-sub-text">SLA đúng hạn: <strong>94.2%</strong></div>
                </div>

                <div className="kpi-box">
                    <div className="kpi-box-title">GIỜ LAO ĐỘNG TIẾT KIỆM / THÁNG</div>
                    <div className="kpi-main-val-row">
                        <div className="kpi-main-val" style={{ "color": "var(--cyan)" }}>342 Giờ</div>
                        <i className="fa-solid fa-clock sparkline-icon" style={{ "color": "var(--cyan)" }}></i>
                    </div>
                    <div className="kpi-sub-text">~2.1 Công nhân sự giải phóng</div>
                </div>

                <div className="kpi-box">
                    <div className="kpi-box-title">CÔNG NỢ PHẢI THU (NHÀ THUỐC)</div>
                    <div className="kpi-main-val-row">
                        <div className="kpi-main-val" style={{ "color": "var(--red-light)" }}>8.7 Tỷ</div>
                        <i className="fa-solid fa-circle-dollar-to-slot sparkline-icon" style={{ "color": "var(--red-light)" }}></i>
                    </div>
                    <div className="kpi-sub-text" style={{ "color": "#fca5a5" }}>Quá hạn 30d: 420Tr (4.8%)</div>
                </div>

                <div className="kpi-box">
                    <div className="kpi-box-title">TỒN KHO DƯỢC PHẨM &amp; VẬT TƯ</div>
                    <div className="kpi-main-val-row">
                        <div className="kpi-main-val" style={{ "color": "var(--purple-light)" }}>15.2 Tỷ</div>
                        <i className="fa-solid fa-boxes-stacked sparkline-icon" style={{ "color": "var(--purple-light)" }}></i>
                    </div>
                    <div className="kpi-sub-text">2.450 mã thuốc chothuoc247</div>
                </div>
            </div>

            {/*  Middle Section (3 Columns)  */}
            <div className="middle-grid-3">
                <div className="card-container">
                    <div className="card-header-bar">
                        <div className="card-header-title"><i className="fa-solid fa-chart-line"></i> HIỆU SUẤT VẬN HÀNH &amp; DOANH SỐ</div>
                    </div>
                    <div className="pill-group">
                        <button className={`pill-btn ${activeFilter === 'revenue' ? 'active' : ''}`} onClick={() => switchRevChart('revenue', 'Doanh thu (Tỷ)')} type="button">Doanh thu (Tỷ)</button>
                        <button className={`pill-btn ${activeFilter === 'orders' ? 'active' : ''}`} onClick={() => switchRevChart('orders', 'Đơn hàng CPN')} type="button">Đơn hàng CPN</button>
                        <button className={`pill-btn ${activeFilter === 'savings' ? 'active' : ''}`} onClick={() => switchRevChart('savings', 'Giờ tiết kiệm')} type="button">Giờ tiết kiệm</button>
                        <button className={`pill-btn ${activeFilter === 'pharmacies' ? 'active' : ''}`} onClick={() => switchRevChart('pharmacies', 'Nhà thuốc')} type="button">Nhà thuốc</button>
                    </div>
                    <div className="chart-subtitle">Biểu đồ 7 ngày gần nhất (Thế Thảo Pharma &amp; TopPharma)</div>
                    <div style={{ "height": "175px", "position": "relative" }}>
                        <canvas ref={revCanvasRef} id="chart-rev-7days"></canvas>
                    </div>
                </div>

                <div className="card-container">
                    <div className="card-header-bar">
                        <div className="card-header-title"><i className="fa-solid fa-cubes"></i> TIẾN ĐỘ 4 DỰ ÁN TRỌNG ĐIỂM</div>
                    </div>
                    <div className="donut-wrapper">
                        <div className="donut-chart-box">
                            <canvas ref={nppCanvasRef} id="chart-npp-donut"></canvas>
                            <div className="donut-center-text">
                                <div className="title">TIẾN ĐỘ CHUNG</div>
                                <div className="number">72%</div>
                            </div>
                        </div>
                        <div className="donut-legend-list">
                            <div className="donut-legend-item">
                                <span className="legend-dot-label"><span className="dot dot-green"></span> PRJ-TTP (Thế Thảo)</span>
                                <span style={{ "fontWeight": "700", "color": "#34d399" }}>78% (On Track)</span>
                            </div>
                            <div className="donut-legend-item">
                                <span className="legend-dot-label"><span className="dot dot-blue"></span> PRJ-TOP (TopPharma)</span>
                                <span style={{ "fontWeight": "700", "color": "#60a5fa" }}>64% (Reviewing)</span>
                            </div>
                            <div className="donut-legend-item">
                                <span className="legend-dot-label"><span className="dot dot-yellow"></span> PRJ-TTCE (Tủ Thuốc)</span>
                                <span style={{ "fontWeight": "700", "color": "#fbbf24" }}>85% (Phase 2)</span>
                            </div>
                            <div className="donut-legend-item">
                                <span className="legend-dot-label"><span className="dot dot-red"></span> PRJ-TECHPHA (Tech)</span>
                                <span style={{ "fontWeight": "700", "color": "#f87171" }}>42% (Chờ CSDL)</span>
                            </div>
                        </div>
                    </div>
                    <div style={{ "textAlign": "center", "marginTop": "10px", "borderTop": "1px solid var(--border-subtle)", "paddingTop": "6px" }}>
                        <a className="card-link-more" onClick={() => onNavigate('view-projects')}>Xem chi tiết Milestone 4 Dự án &gt;</a>
                    </div>
                </div>

                <div className="card-container">
                    <div className="card-header-bar">
                        <div className="card-header-title"><i className="fa-solid fa-triangle-exclamation" style={{ "color": "var(--red)" }}></i> CẢNH BÁO &amp; ĐIỂM NGHẼN</div>
                        <a className="card-link-more" onClick={() => onNavigate('view-risks')}>Xem tất cả &gt;</a>
                    </div>
                    <div className="risk-item-list">
                        <div className="risk-item-card">
                            <div className="risk-item-left">
                                <div className="risk-icon-box risk-icon-red"><i className="fa-solid fa-triangle-exclamation"></i></div>
                                <div className="risk-text-info">
                                    <div className="title">Nợ quá hạn 30 ngày: 5 Nhà thuốc</div>
                                    <div className="sub">Tổng công nợ: 420 Triệu đ</div>
                                </div>
                            </div>
                            <button className="btn-risk-action btn-risk-red" onClick={() => onShowToast('Đã kích hoạt BOT Kế toán gửi lịch đối soát!')}>Cần xử lý</button>
                        </div>
                        <div className="risk-item-card">
                            <div className="risk-item-left">
                                <div className="risk-icon-box risk-icon-orange"><i className="fa-solid fa-box-open"></i></div>
                                <div className="risk-text-info">
                                    <div className="title">Tồn kho cận date (&lt; tháng): 8 mã</div>
                                    <div className="sub">Giá trị: 120 Triệu đ</div>
                                </div>
                            </div>
                            <button className="btn-risk-action btn-risk-orange" onClick={() => onShowToast('Đã chuyển Marketing chạy Flash Deal xả kho!')}>Cần xử lý</button>
                        </div>
                        <div className="risk-item-card">
                            <div className="risk-item-left">
                                <div className="risk-icon-box risk-icon-yellow"><i className="fa-solid fa-database"></i></div>
                                <div className="risk-text-info">
                                    <div className="title">Nghẽn CSDL Techpha: Chờ mã BYT</div>
                                    <div className="sub">Chậm 24h so với tiến độ R&D</div>
                                </div>
                            </div>
                            <button className="btn-risk-action btn-risk-yellow" onClick={() => onShowToast('Đang đôn đốc nạp CSDL Dược điển!')}>Theo dõi</button>
                        </div>
                        <div className="risk-item-card">
                            <div className="risk-item-left">
                                <div className="risk-icon-box risk-icon-blue"><i className="fa-solid fa-file-invoice-dollar"></i></div>
                                <div className="risk-text-info">
                                    <div className="title">PO Thu mua cần tách HĐ VAT: 3 đơn</div>
                                    <div className="sub">Giá trị: 350 Triệu đ</div>
                                </div>
                            </div>
                            <button className="btn-risk-action btn-risk-blue" onClick={() => onShowToast('Đã gửi bảng tính tách thuế cho Kế toán!')}>Xử lý ngay</button>
                        </div>
                    </div>
                </div>
            </div>

            {/*  5 Department Agent Fleet Row  */}
            <div className="agents-row-5">
                <div className="agent-card">
                    <div>
                        <div className="agent-card-top">
                            <div className="agent-id-box">
                                <div className="agent-icon-wrap" style={{ "background": "rgba(168, 85, 247, 0.15)", "color": "#c084fc" }}><i className="fa-solid fa-bullhorn"></i></div>
                                <div>
                                    <div className="agent-name-title">MARKETING</div>
                                    <div className="agent-name-sub">AGENT BOT</div>
                                </div>
                            </div>
                            <div className="agent-work-count">4 tasks</div>
                        </div>
                        <div className="agent-bullets">
                            <div className="agent-bullet-item"><i className="fa-solid fa-check"></i> <span>Video Batch PRJ-TTP: <strong>Chờ duyệt</strong></span></div>
                            <div className="agent-bullet-item"><i className="fa-solid fa-check"></i> <span>Kịch bản TikTok Dược: <strong>90%</strong></span></div>
                            <div className="agent-bullet-item"><i className="fa-solid fa-check"></i> <span>Truy vấn kho chothuoc247: <strong>OK</strong></span></div>
                            <div className="agent-bullet-item"><i className="fa-solid fa-check"></i> <span>Đơn hàng từ MKT: <strong>185 Triệu</strong></span></div>
                        </div>
                    </div>
                    <a className="agent-bottom-link" onClick={() => onNavigate('view-dept-mkt')}>Vào Dashboard Marketing &gt;</a>
                </div>

                <div className="agent-card">
                    <div>
                        <div className="agent-card-top">
                            <div className="agent-id-box">
                                <div className="agent-icon-wrap" style={{ "background": "rgba(249, 115, 22, 0.15)", "color": "#fb923c" }}><i className="fa-solid fa-cart-shopping"></i></div>
                                <div>
                                    <div className="agent-name-title">THU MUA</div>
                                    <div className="agent-name-sub">AGENT BOT</div>
                                </div>
                            </div>
                            <div className="agent-work-count">3 tasks</div>
                        </div>
                        <div className="agent-bullets">
                            <div className="agent-bullet-item"><i className="fa-solid fa-check"></i> <span>Phân bổ PO NCC1/NCC2: <strong>OK</strong></span></div>
                            <div className="agent-bullet-item"><i className="fa-solid fa-check"></i> <span>Tách HĐ VAT &amp; tiền ngoài: <strong>12 NCC</strong></span></div>
                            <div className="agent-bullet-item"><i className="fa-solid fa-check"></i> <span>Tiết kiệm deal rẻ: <strong>8.4 Triệu</strong></span></div>
                            <div className="agent-bullet-item"><i className="fa-solid fa-check"></i> <span>Đơn hàng chờ duyệt: <strong>1 PO</strong></span></div>
                        </div>
                    </div>
                    <a className="agent-bottom-link" onClick={() => onNavigate('view-dept-proc')}>Vào Dashboard Thu Mua &gt;</a>
                </div>

                <div className="agent-card">
                    <div>
                        <div className="agent-card-top">
                            <div className="agent-id-box">
                                <div className="agent-icon-wrap" style={{ "background": "rgba(59, 130, 246, 0.15)", "color": "#60a5fa" }}><i className="fa-solid fa-warehouse"></i></div>
                                <div>
                                    <div className="agent-name-title">KHO VẬN</div>
                                    <div className="agent-name-sub">AGENT BOT</div>
                                </div>
                            </div>
                            <div className="agent-work-count">2 tasks</div>
                        </div>
                        <div className="agent-bullets">
                            <div className="agent-bullet-item"><i className="fa-solid fa-check"></i> <span>85 Đơn CPN xuất PDF: <strong>Đã in nhãn</strong></span></div>
                            <div className="agent-bullet-item"><i className="fa-solid fa-check"></i> <span>Tỷ lệ giao đúng hạn: <strong>98.2%</strong></span></div>
                            <div className="agent-bullet-item"><i className="fa-solid fa-check"></i> <span>Đồng bộ tồn chothuoc247: <strong>0ms</strong></span></div>
                            <div className="agent-bullet-item"><i className="fa-solid fa-check"></i> <span>Cảnh báo tồn an toàn: <strong>1 mã</strong></span></div>
                        </div>
                    </div>
                    <a className="agent-bottom-link" onClick={() => onNavigate('view-dept-log')}>Vào Dashboard Kho Vận &gt;</a>
                </div>

                <div className="agent-card">
                    <div>
                        <div className="agent-card-top">
                            <div className="agent-id-box">
                                <div className="agent-icon-wrap" style={{ "background": "rgba(34, 197, 94, 0.15)", "color": "#4ade80" }}><i className="fa-solid fa-calculator"></i></div>
                                <div>
                                    <div className="agent-name-title">KẾ TOÁN</div>
                                    <div className="agent-name-sub">AGENT BOT</div>
                                </div>
                            </div>
                            <div className="agent-work-count">3 tasks</div>
                        </div>
                        <div className="agent-bullets">
                            <div className="agent-bullet-item"><i className="fa-solid fa-check"></i> <span>Hoa hồng Nhóm 1,2,3: <strong>Hoàn tất</strong></span></div>
                            <div className="agent-bullet-item"><i className="fa-solid fa-check"></i> <span>Đối soát ngân hàng: <strong>OK</strong></span></div>
                            <div className="agent-bullet-item"><i className="fa-solid fa-check"></i> <span>Thu/chi hôm qua: <strong>+380 Triệu</strong></span></div>
                            <div className="agent-bullet-item"><i className="fa-solid fa-check"></i> <span>Bảng hoa hồng: <strong>Chờ duyệt BOD</strong></span></div>
                        </div>
                    </div>
                    <a className="agent-bottom-link" onClick={() => onNavigate('view-dept-acc')}>Vào Dashboard Kế Toán &gt;</a>
                </div>

                <div className="agent-card">
                    <div>
                        <div className="agent-card-top">
                            <div className="agent-id-box">
                                <div className="agent-icon-wrap" style={{ "background": "rgba(236, 72, 153, 0.15)", "color": "#f472b6" }}><i className="fa-solid fa-users-gear"></i></div>
                                <div>
                                    <div className="agent-name-title">HCNS</div>
                                    <div className="agent-name-sub">AGENT BOT</div>
                                </div>
                            </div>
                            <div className="agent-work-count">2 tasks</div>
                        </div>
                        <div className="agent-bullets">
                            <div className="agent-bullet-item"><i className="fa-solid fa-check"></i> <span>OCR CCCD 2 mặt: <strong>100% khớp</strong></span></div>
                            <div className="agent-bullet-item"><i className="fa-solid fa-check"></i> <span>Lark Base VPP &amp; QR: <strong>Tự động</strong></span></div>
                            <div className="agent-bullet-item"><i className="fa-solid fa-check"></i> <span>Tuyển dụng Dược sĩ: <strong>2 hồ sơ</strong></span></div>
                            <div className="agent-bullet-item"><i className="fa-solid fa-check"></i> <span>Nghỉ việc tháng này: <strong>0 người</strong></span></div>
                        </div>
                    </div>
                    <a className="agent-bottom-link" onClick={() => onNavigate('view-dept-hr')}>Vào Dashboard HCNS &gt;</a>
                </div>

                <div className="agent-card">
                    <div>
                        <div className="agent-card-top">
                            <div className="agent-id-box">
                                <div className="agent-icon-wrap" style={{ "background": "rgba(56, 189, 248, 0.15)", "color": "#38bdf8" }}><i className="fa-solid fa-user-tie"></i></div>
                                <div>
                                    <div className="agent-name-title">{troLyData?.cockpit_card?.title || 'TRỢ LÝ CÔNG NGHỆ'}</div>
                                    <div className="agent-name-sub">{troLyData?.cockpit_card?.sub_title || 'AI & SYSTEM BOT'}</div>
                                </div>
                            </div>
                            <div className="agent-work-count">{troLyData?.cockpit_card?.work_count || '—'}</div>
                        </div>
                        <div className="agent-bullets">
                            {(troLyData?.cockpit_card?.bullets || []).map((b, idx) => (
                                <div className="agent-bullet-item" key={idx}>
                                    <i className={`fa-solid ${b.icon}`}></i> <span dangerouslySetInnerHTML={{ __html: b.text }} />
                                </div>
                            ))}
                            {!troLyData && (
                                <div className="agent-bullet-item"><i className="fa-solid fa-spinner fa-spin"></i> <span>Đang tải dữ liệu…</span></div>
                            )}
                        </div>
                    </div>
                    <a className="agent-bottom-link" onClick={() => onNavigate('view-dept-assist')}>Vào Dashboard Ban Trợ Lý &gt;</a>
                </div>
            </div>

            {/*  Bottom Section (3 Columns)  */}
            <div className="bottom-grid-3">
                <div className="card-container">
                    <div className="card-header-bar">
                        <div className="card-header-title"><i className="fa-solid fa-brain"></i> OPENCLAW BRAIN — TRI THỨC AGENTIC</div>
                        <span style={{ "fontSize": "10px", "color": "var(--gold-light)", "fontWeight": "700" }}>12 Cập nhật</span>
                    </div>
                    <div className="brain-item-list">
                        <div className="brain-item">
                            <div className="brain-icon-box" style={{ "background": "rgba(59, 130, 246, 0.15)", "color": "#60a5fa" }}><i className="fa-solid fa-microchip"></i></div>
                            <div className="brain-text">
                                <div className="title">5 AI Skills mới được nạp vào Router</div>
                                <div className="sub">Video Batch Gen, PO Split NCC, CCCD OCR, Commission Matrix, Stock Watchdog</div>
                            </div>
                        </div>
                        <div className="brain-item">
                            <div className="brain-icon-box" style={{ "background": "rgba(34, 197, 94, 0.15)", "color": "#4ade80" }}><i className="fa-solid fa-file-shield"></i></div>
                            <div className="brain-text">
                                <div className="title">3 SOP Dược Phẩm &amp; Quy Trình Kho</div>
                                <div className="sub">Bán hàng Nhà thuốc, Xử lý công nợ Dược, Nhập xuất kho chothuoc247</div>
                            </div>
                        </div>
                    </div>
                    <div style={{ "textAlign": "center", "marginTop": "10px", "borderTop": "1px solid var(--border-subtle)", "paddingTop": "6px" }}>
                        <a className="card-link-more" onClick={() => onOpenModal('modal-brain')}>Xem chi tiết OpenClaw Brain &gt;</a>
                    </div>
                </div>

                <div className="card-container" style={{ "border": "1px solid var(--gold-border)", "background": "linear-gradient(180deg, #191f2c 0%, #12151e 100%)" }}>
                    <div className="card-header-bar">
                        <div className="card-header-title" style={{ "color": "var(--gold-light)" }}><i className="fa-solid fa-signature"></i> 3 VIỆC LÃNH ĐẠO CẦN DUYỆT (BOD)</div>
                        <a className="card-link-more" onClick={() => onOpenModal('modal-decisions')}>Xem tất cả &gt;</a>
                    </div>
                    <div className="decision-item-list">
                        <div className="decision-item">
                            <div className="decision-number-badge">1</div>
                            <div>Phê duyệt ngân sách Video Marketing PRJ-TTP: <strong>5.000.000 đ</strong></div>
                        </div>
                        <div className="decision-item">
                            <div className="decision-number-badge">2</div>
                            <div>Duyệt bảng tính hoa hồng kinh doanh Kỳ 1 Tháng 8: <strong>48.500.000 đ</strong></div>
                        </div>
                        <div className="decision-item">
                            <div className="decision-number-badge">3</div>
                            <div>Nghiệm thu đơn PO tách HĐ VAT 500 hộp thuốc Thu mua</div>
                        </div>
                    </div>
                    <button className="btn-decision-cta" onClick={() => onOpenModal('modal-decisions')}>
                        Xem &amp; Phê Duyệt 1-Click &gt;
                    </button>
                </div>

                <div className="card-container">
                    <div className="card-header-bar">
                        <div className="card-header-title"><i className="fa-solid fa-calendar-check"></i> LỊCH TRÌNH ĐIỀU HÀNH HÔM NAY</div>
                        <a className="card-link-more" onClick={() => onShowToast('Xem lịch trình tuần...')}>Xem lịch &gt;</a>
                    </div>
                    <div className="schedule-timeline">
                        <div className="schedule-entry">
                            <span className="schedule-time">09:00</span>
                            <span className="schedule-text">Họp giao ban tiến độ 4 Dự án (TTP, TOP, TTCE, TECH)</span>
                        </div>
                        <div className="schedule-entry">
                            <span className="schedule-time">11:00</span>
                            <span className="schedule-text">Duyệt bảng nghiệm thu PO Thu Mua &amp; Kế Toán</span>
                        </div>
                        <div className="schedule-entry">
                            <span className="schedule-time">14:00</span>
                            <span className="schedule-text">Rà soát quy trình kho vận &amp; cổng API CPN</span>
                        </div>
                        <div className="schedule-entry">
                            <span className="schedule-time">16:00</span>
                            <span className="schedule-text">Tổng kết chỉ số SLA các BOT phòng ban</span>
                        </div>
                    </div>
                    <button className="btn-add-schedule" onClick={() => onShowToast('Mở form tạo lịch điều hành mới...')}>
                        <i className="fa-solid fa-plus"></i> Thêm lịch điều hành
                    </button>
                </div>
            </div>

            {/*  Cockpit Footer Slogan  */}
            <div className="cockpit-footer-slogan">
                <i className="fa-solid fa-crown" style={{ "color": "var(--gold)" }}></i> TẬP TRUNG VÀO QUYẾT ĐỊNH – ĐỂ HỆ THỐNG AI AGENTIC TỰ ĐỘNG VẬN HÀNH
            </div>

        </div>
    );
}
